export const citiesByCountry: Record<string, string[]> = {
  Chile: [
    "Santiago",
    "Valparaíso",
    "Viña del Mar",
    "Concepción",
    "La Serena",
    "Antofagasta",
    "Temuco",
    "Puerto Montt",
    "Iquique",
    "Rancagua",
    "Talca",
    "Arica",
    "Copiapó",
    "Punta Arenas",
    "Chillán",
  ],
  Brazil: [
    "São Paulo",
    "Rio de Janeiro",
    "Brasília",
    "Salvador",
    "Fortaleza",
    "Belo Horizonte",
    "Curitiba",
    "Manaus",
    "Recife",
    "Porto Alegre",
    "Belém",
    "Goiânia",
    "Campinas",
    "São Luís",
    "Natal",
  ],
}; 